import { Logo } from "@/components/brand/Logo";
import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };
  return (
    <div className="page-safe flex min-h-[100dvh] flex-col items-center justify-center bg-background px-4 py-8">
      <div className="w-full max-w-md">
        <div className="relative rounded-2xl border border-border bg-card p-6 shadow-sm sm:p-8">
          <button
            type="button"
            onClick={handleBack}
            aria-label="Torna indietro"
            className="absolute left-4 top-4 inline-flex cursor-pointer items-center gap-1 text-[13px] text-muted-foreground transition-colors hover:text-foreground sm:left-5 sm:top-5"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Indietro
          </button>
          <div className="mb-6 flex flex-col items-center text-center">
            <Logo size="lg" />
            <h1 className="mt-4 text-xl font-semibold tracking-tight text-foreground">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
            ) : (
              /* NON PIU' "Beta privata" (26/08/2026). Questa riga sta sotto il
                 logo di OGNI pagina di accesso: e' la primissima cosa che legge
                 un revisore di Apple, e le linee guida escludono dallo store le
                 versioni di prova. Il commento in Settings dava per tolto questo
                 banner: non era vero, era rimasto qui. Il senso resta - il
                 servizio e' per professionisti - senza la parola che invita al
                 rifiuto. */
              <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">
                Riservato agli installatori professionisti
              </p>
            )}
          </div>
          {children}
          {footer ? <div className="mt-6 text-center text-sm">{footer}</div> : null}
        </div>
        <p className="mt-4 text-center text-xs text-muted-foreground">
          Hai problemi?{" "}
          <a href="mailto:u.chiatti@datacomtecnologie.it" className="text-primary hover:underline">
            Contatta Datacom
          </a>
        </p>
      </div>
    </div>
  );
}